import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fixed inset-0 z-50 flex items-center justify-center p-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "absolute inset-0 bg-black bg-opacity-50" }, null, -1)
const _hoisted_3 = { class: "relative mx-auto z-10 overflow-hidden rounded-lg bg-white px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:w-2/5 sm:p-6" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "text-dark-blue text-2xl font-roboto text-center mb-3" }, " Please Select Date ", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-dark-blue text-base text-center" }, " Please select a date range to extract Balance ", -1)
const _hoisted_6 = { class: "flex justify-between mt-4" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { class: "text-dark-blue" }, "From Date*", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { class: "text-dark-blue" }, "To Date*", -1)
const _hoisted_9 = { class: "flex justify-between mt-6" }

import {PropType, ref} from 'vue';
import {ReportRequestDto} from "@/areas/reports/dtos/reportRequestDto";
import {useReportStore} from "@/areas/reports/stores/reportStore";
import {ReportType} from "@/areas/reports/enums/reportType";


export default /*#__PURE__*/_defineComponent({
  __name: 'FromToDateModal',
  props: {
  isDateModalOpen: Boolean,
  reportRequestDto: {
    type: Object as PropType<ReportRequestDto>,
    required: true,
  },
},
  emits: ['close', 'download'],
  setup(__props, { emit: __emit }) {

const props = __props

const emits = __emit

const reportRequestDto = ref(props.reportRequestDto)

const reportStore = useReportStore();


return (_ctx: any,_cache: any) => {
  return (__props.isDateModalOpen)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_7,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((reportRequestDto.value.from) = $event)),
                type: "date",
                class: "border border-gray-300 rounded-lg py-2 pl-2 pr-2 outline-none shadow-sm w-full mt-1.5"
              }, null, 512), [
                [_vModelText, reportRequestDto.value.from]
              ])
            ], 512), [
              [_vShow, reportRequestDto.value.reportType !== _unref(ReportType).Balances]
            ]),
            _createElementVNode("div", null, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((reportRequestDto.value.to) = $event)),
                type: "date",
                class: "border border-gray-300 rounded-lg py-2 pl-2 pr-2 outline-none shadow-sm w-full mt-1.5"
              }, null, 512), [
                [_vModelText, reportRequestDto.value.to]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close'))),
              class: "flex items-center px-5 py-2 rounded-md shadow-md bg-transparent text-dark-blue border border-dark-blue"
            }, " Cancel "),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('download'))),
              class: _normalizeClass([_unref(reportStore).isLoading ? 'disabled bg-gray-500' : 'bg-light-blue', "flex items-center px-5 py-2 rounded-md shadow-md text-white"])
            }, " Continue ", 2)
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})